import React from "react";
import dayjs from "dayjs";
import { Badge } from "reactstrap";

const CreatorDetails = ({ creator, date }) => {

    return (
        <React.Fragment>
            <p class="mb-0">
                <span class="mr-2"> {creator?.name} </span>
                <Badge
                    color="info"
                >
                    {creator?.uniqueUserId}
                </Badge>
                <span class="ml-2"> |  {dayjs(date).format('MMM DD, YYYY hh:mm A')} </span>
            </p>
        </React.Fragment>
    )
}
export default CreatorDetails;
